import { Avatar } from "../shared";

const DesktopNav = ({ tab, setTab, unreadCount = 0, chatCount = 0, user }) => {
  const links = [
    { id: "find",   label: "Find a Ride" },
    { id: "post",   label: "Post a Trip" },
    { id: "trips",  label: "My Trips" },
    { id: "chat",   label: "Chat",   badge: chatCount },
    { id: "notifs", label: "Alerts", badge: unreadCount },
  ];

  return (
    <header className="d-topnav">
      <div className="d-nav-logo" onClick={() => setTab("find")}>iGo</div>
      <nav className="d-nav-links">
        {links.map(({ id, label, badge }) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            className={`d-nav-link${tab === id ? " active" : ""}`}
          >
            {label}
            {badge > 0 && (
              <span className="d-nav-badge">{badge > 99 ? "99+" : badge}</span>
            )}
          </button>
        ))}
      </nav>
      {user && (
        <button className="d-nav-user" onClick={() => setTab("profile")}>
          <Avatar user={user} size={28} tappable={false}/>
          <span>{user.name}</span>
        </button>
      )}
    </header>
  );
};

export default DesktopNav;
